import {
  Component,
  ChangeDetectionStrategy,
  inject,
  input,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { buildDate, commitHash } from '../../environments/version';

const compactNavigationQuery = '(max-width: 48rem)';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SideNavComponent {
  readonly navigationVisible = input(true);
  protected readonly frontendVersionInfo = commitHash.substring(0, 20);
  protected readonly frontendBuildDate = buildDate;
  protected readonly commitHash = commitHash;
  private readonly breakpoints = inject(BreakpointObserver);
  private readonly router = inject(Router);
  protected readonly isCompact = signal(
    this.breakpoints.isMatched(compactNavigationQuery),
  );
  protected readonly mobileNavigationOpen = signal(false);

  constructor() {
    this.breakpoints
      .observe(compactNavigationQuery)
      .pipe(takeUntilDestroyed())
      .subscribe(({ matches }) => {
        this.isCompact.set(matches);
        this.mobileNavigationOpen.set(false);
      });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.closeMobileNavigation());
  }

  protected toggleNavigation() {
    this.mobileNavigationOpen.update((opened) => !opened);
  }

  protected closeMobileNavigation() {
    this.mobileNavigationOpen.set(false);
  }

  protected onOpenedChange(opened: boolean) {
    if (this.isCompact()) this.mobileNavigationOpen.set(opened);
  }

  navigationItems: NavigationLink[] = [
    { link: '/', displayName: 'Tenants' },
    { link: '/inquiries', displayName: 'Anfragen' },
    { link: '/static-templates', displayName: 'Static Templates' },
    { link: '/sms-texts', displayName: 'SMS-Texte' },
    { link: '/debug', displayName: 'Inquiry-Infos' },
    { link: '/hangfire', displayName: 'Hangfire' },
    { link: '/revenue', displayName: 'Umsatz' },
  ];
}

export interface NavigationLink {
  link: string;
  displayName: string;
}
